/**
 * expired_at is still a date string after a subscription lapses or is canceled,
 * so a null check is not enough — compare it against now, as the sidebar does.
 */
export const hasActiveAccess = (user) =>
  !!user?.expired_at && new Date(user.expired_at) > new Date();
